// src/components/ContextMenu.js
import React, { useEffect, useRef } from 'react';

export default function ContextMenu({ x, y, options, onRequestClose }) {
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onRequestClose();
      }
    };
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        onRequestClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [onRequestClose]);

  if (!options?.length) return null;

  const handleAction = (action) => {
    action();
    onRequestClose();
  };

  return (
    <div
      ref={ref}
      className="context-menu"
      style={{ top: y, left: x }}
    >
      {options.map((option, index) => (
        <button key={index} className="context-menu-item" onClick={()=>handleAction(option.action)}>
          {option.label}
        </button>
      ))}
    </div>
  );
}
